import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Card,
  CardHeader,
  CardContent,
  TextField,
  InputAdornment,
} from '@mui/material';
import { useApiGet } from '../../../utils/httpClientTs';
import { getOverseasContacts } from '../../../endpoints/chaptersTs';
import { Search } from '@mui/icons-material';
import PositionDisplay from '../../../Components/PositionDisplay';

interface ReciprocityMember {
  id: string;
  role: string;
  name: string;
  role_id: string;
  user_id: string;
  start_date: string;
  end_date: string | null;
  order: number;
}

interface Reciprocity {
  id: string;
  name: string;
  description: string;
  members: ReciprocityMember[];
}

const IntlMembers: React.FC = () => {
  const [search, setSearch] = useState<string>('');
  const [filteredReciprocities, setFilteredReciprocities] = useState<
    Reciprocity[]
  >([]);

  const { data: reciprocityData, isFetching } = useApiGet<Reciprocity[]>(
    ['intl-leadership'],
    getOverseasContacts,
    {
      enabled: true,
      retry: 1,
    },
    {}
  );

  useEffect(() => {
    if (reciprocityData && reciprocityData.length > 0 && search.length > 0) {
      const filtered = reciprocityData.filter((reciprocity) =>
        reciprocity.name.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredReciprocities(filtered);
    } else {
      if (reciprocityData && reciprocityData.length > 0) {
        setFilteredReciprocities(reciprocityData);
      } else {
        setFilteredReciprocities([]);
      }
    }
  }, [reciprocityData, search]);

  if (isFetching) {
    return (
      <Grid item xs={12} textAlign={'center'} paddingTop={2}>
        <Typography variant="body1">Loading...</Typography>
      </Grid>
    );
  }

  if (!reciprocityData) {
    return (
      <Grid item xs={12} textAlign={'center'} paddingTop={2}>
        <Typography variant="body1">No data available</Typography>
      </Grid>
    );
  }

  return (
    <Grid container>
      {reciprocityData?.length > 2 && (
        <Grid item xs={12} sx={{ padding: 2 }}>
          <TextField
            label="Search"
            id="search-field"
            size="small"
            value={search}
            fullWidth={true}
            onChange={(event) => setSearch(event.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      )}
      {filteredReciprocities?.map((reciprocity) => (
        <Grid item xs={12} md={6} sx={{ padding: 2 }} key={reciprocity.id}>
          <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
            <CardHeader
              title={reciprocity.name}
              subheader={reciprocity.description}
              sx={{ p: 1 }}
            />
            <CardContent sx={{ p: 1 }}>
              <Grid container spacing={2}>
                {reciprocity.members
                  .sort((a, b) => a.order - b.order)
                  .map((member) => (
                    <PositionDisplay
                      id={member.id}
                      position={member.role}
                      positionId={member.role_id}
                      committeeId={null}
                      name={member.name}
                      startDate={member.start_date}
                      endDate={member.end_date}
                      canEdit={false}
                      isSaving={false}
                      errorSavingText={null}
                      onSave={null}
                      userId={member.user_id}
                      pageFrom={'intl-appointments'}
                      canMessage={true}
                    />
                  ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default IntlMembers;
